// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Quote_wrapper__00ei9","block":"Quote_block__m1uel","quote":"Quote_quote__qTU2R","cite":"Quote_cite__RRpMP"};